/**
 * What: Prefixes <style> selectors with #scopeId (e.g. `table{}` → `#id table{}`).
 * Why:  Prevents LLM CSS from leaking into the rest of the UI.
 */
export function scopeEmbeddedStyles(html: string, scopeId: string): string {
  if (!html) return html

  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = html

  tempDiv.querySelectorAll('style').forEach((styleEl) => {
    const original = styleEl.textContent ?? ''
    const scoped = original.replace(/([^{}]+)\{/g, (match, selectors: string) => {
      // Skip at-rules (@media, @font-face, @keyframes, @supports, etc.)
      // Prefixing them produces invalid CSS that silently breaks the entire block.
      if (selectors.trim().startsWith('@')) return match
      return (
        selectors
          .split(',')
          .map((s: string) => `#${scopeId} ${s.trim()}`)
          .join(', ') + ' {'
      )
    })
    styleEl.textContent = scoped
  })

  return tempDiv.innerHTML
}
